import { render } from "./FooterCentral.vue?vue&type=template&id=47c7c11d"
import script from "./FooterCentral.vue?vue&type=script&lang=js"
export * from "./FooterCentral.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pulsell/data/www/driver.pulsell.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__